import { Component, OnInit, Output, EventEmitter, Input, TemplateRef, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import { ToastrService } from 'ngx-toastr';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import * as jwt_decode from 'jwt-decode';
import { ContactsVm, FilteredContactVm } from 'src/app/viewModels/core/contacts-vm';

import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { ContactsService } from 'src/app/applicationModules/core/services/contacts.service';
import { MatDialog } from '@angular/material/dialog';
import { MatAutocomplete, MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import { DataSharingService } from '../resuableServices/data-sharing.service';
import { CompanysVm, FilteredCompanyVm } from 'src/app/viewModels/core/company-vm';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/middleware/common/reusableComponents/confirm-dialog/confirm-dialog.component';
import { ModuleName } from '../Enum/common.enum';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { CoreVm } from 'src/app/viewModels/core/core-vm';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string,
}

@Component({
  selector: 'app-associate-core',
  templateUrl: './associate-core.component.html',
  styleUrls: ['./associate-core.component.scss']
})
export class AssociateCoreComponent implements OnInit {
  @Input() datalist: any = [];
  @Input() coreID: number;
  @Input() TypeIdDrp: number = 0;
  @Input() RerenderKey: number = 0;
  showdetail: boolean = true;
  addnewContact: boolean = false;
  showAddContact: boolean = false;
  addnewSharedContact: boolean = false;
  isSharedAccessRolePopup: boolean = false;
  isSharedAccessUserPopup: boolean = false;
  Module: string;
  filteredroles: Observable<string[]>;
  value = '';
  Owners: any = [] = [];
  NormalCore: any = [];
  NormalContacts: any = [];
  NormalCompanys: any = [];
  SharedContacts: any = [];
  SharedRoleList: any = [];
  stateCtrlValue: string = "";
  @Output() showContactDetail = new EventEmitter<boolean>();
  currentUser: any;
  databaseId: string;
  organizationId: string;
  responseHolder: any;
  contactsList: any = [];
  companysList: any = [];
  isShare: boolean = false;
  showAddButton = false;
  showCompanyRoleAddButton = false;
  showContactRoleAddButton = false;
  searchName: string = '';
  roleCtrl = new FormControl();
  allTransRoles: any = [{ name: 'Buyer' }, { name: 'Seller' }, { name: 'Agent' }];
  selectedRoles: any = [];
  @ViewChild('roleInput') roleInput: ElementRef<HTMLInputElement>;
  @ViewChild('auto') matAutocomplete: MatAutocomplete;
  separatorKeysCodes: number[] = [ENTER, COMMA];
  selectable = true;
  removable = true;
  isRolePopup: boolean = false;
  Roles: any = [];
  RolesCompany: any = [];
  transRoleList: any = [];
  sharedAccessRoleList: any = [];
  sharedAccessUserList: any = [];
  selectedsharedAccessRole: any = [];
  currentRoleContact: any;
  currentRoleCompany: any;
  showDetail: boolean = false;
  TransactionId: number = 0;
  peoples: any = [];
  selectedcompanyList: any = [];
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  mainModuleName: string = "";
  SelectedModuleName: any = [] = [];
  CompanyName: string = "";
  CoreName: string = "";
  ContactName: string = "";
  OfficeIDList: any = [];
  myOfficeID: any;
  clickEventsubscriptionPreviousNextC: any;
  clickEventsubscriptionListRefreshCore: any;

  constructor(private statusConst: StatusConstant, private loaderService: LoaderService,
    private contactsService: ContactsService, private toastr: ToastrService, private filteredContactVm: FilteredContactVm,
    private filteredCompanyVm: FilteredCompanyVm,
    private contactsVm: ContactsVm, private companysVm: CompanysVm,
    private encryptionAlgo: EncryptionService, private reusableClass: ReusableClasses,
    private dialog: MatDialog, private cdr: ChangeDetectorRef,
    private _dataSharingService: DataSharingService, private coreVm: CoreVm,) {

    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

    this.filteredroles = this.roleCtrl.valueChanges.pipe(startWith(null), map((fruit: string | null) => fruit ? this._filter(fruit) : this.allTransRoles.slice()));
    this.filteredStates = this.stateCtrl.valueChanges.pipe(startWith(''), map(state => state ? this._filterStates(state) : this.states.slice()));
    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID)
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });
  }

  ngAfterContentChecked() {
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this.clickEventsubscriptionPreviousNextC.unsubscribe();
    //this.clickEventsubscriptionListRefreshCore.unsubscribe();
  }

  ngOnInit(): void {
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var coreName = [];
    coreName = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core);
    if (coreName.length > 0) {
      this.CoreName = coreName[0].orgModuleName;
      this.mainModuleName = coreName[0].mainModuleName;//"Core";
      this.CorefolderID = coreName[0].folderID;
    }

    var contName = [];
    contName = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Contact);
    if (contName.length > 0) {
      this.ContactName = contName[0].orgModuleName;
      // this.mainModuleName=contName[0].mainModuleName;//"Core";
    }
    var compName = [];
    compName = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Company);
    if (compName.length > 0) {
      this.CompanyName = compName[0].orgModuleName;
      // this.mainModuleName=compName[0].mainModuleName;//"Core";
    }

    this.clickEventsubscriptionPreviousNextC = this._dataSharingService.getNextPreviousForRightPanelFromCore().subscribe((result) => {
      if (result) {
        this.showAddButton = false;
        this.showCompanyRoleAddButton = false;
        this.showContactRoleAddButton = false;
        this.Owners = [];
        this.NormalCompanys = [];
        this.NormalContacts = [];
        this.SharedContacts = [];
        this.NormalCore = [];
        this.getCoreSelectedCores();
        this.getNormalAndSharedContacts();
        this.getNormalAndSharedCompanys();
      }
    });

    this.clickEventsubscriptionListRefreshCore = this._dataSharingService.getRefreshListFromCore().subscribe((result) => {
      if (result) {
        this.getCoreSelectedCores();
        this.getNormalAndSharedContacts();
        this.getNormalAndSharedCompanys();
      }
    });
    this.showAddButton = false;
    this.showCompanyRoleAddButton = false;
    this.showContactRoleAddButton = false;
    this.Owners = [];
    this.NormalCompanys = [];
    this.NormalContacts = [];
    this.SharedContacts = [];
    this.NormalCore = [];
    this.getCoreSelectedCores();
    this.getNormalAndSharedContacts();
    this.getNormalAndSharedCompanys();
  }

  getCloseDetail(message:any) {
    this.showDetail = message;
  }

  addNew(module:any) {
    this.Module = module;
    this.showAddContact = !this.showAddContact;
  }

  getClose(message:any) {
    this.showAddContact = message;
  }

  addContact() {
    this.addnewContact = !this.addnewContact;
  }

  addSharedContact() {
    this.addnewSharedContact = !this.addnewSharedContact;
  }

  private _filterStates(value: string): State[] {
    const filterValue = value.toLowerCase();
    return this.states.filter(state => state.name.toLowerCase().indexOf(filterValue) === 0);
  }

  remove(fruit: string): void {
    const index = this.selectedRoles.indexOf(fruit);
    if (index >= 0) {
      this.selectedRoles.splice(index, 1);
    }
  }

  add(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value.toLowerCase();

    // Add our fruit
    if ((value || '').trim()) {
      var arrToUp = String.prototype.toLowerCase.apply(this.selectedRoles).split(",");
      const index = arrToUp.indexOf(value.trim());

      if (index >= 0) {
        //this.fruits.splice(index, 1);
      }
      else {
        this.selectedRoles.push(event.value.trim());
      }
    }
    // Reset the input value
    if (input) {
      input.value = '';
    }
    this.roleCtrl.setValue(null);
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    const index = this.selectedRoles.indexOf(event.option.viewValue);
    if (index >= 0) {
      this.roleInput.nativeElement.value = '';
    }
    else {
      this.selectedRoles.push(event.option.viewValue);
      this.roleInput.nativeElement.value = '';
      this.roleCtrl.setValue(null);
    }
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    return this.allTransRoles.filter(fruit => fruit.name.toLowerCase().indexOf(filterValue) === 0);
  }

  getCloseDetails(message) {
    this.showDetail = false;
  }

  contactDetail(detail) {
    if (detail.userID > 0) {
      return;
    }
    this.Module = "Contact";
    this.TransactionId = detail.contactID;
    this.showDetail = !this.showDetail;
  }

   coreDetail(detail) {   
    this.Module = "Core";
    this.TransactionId = detail.attachedCoreID;
    this.showDetail = !this.showDetail;
  }

  companyDetail(detail) {
    this.Module = "Company";
    this.TransactionId = detail.companyID;
    this.showDetail = !this.showDetail;
  }

  PCCPatientIDShow: boolean = false;
  folderId: number = 0;
  PCCPatientIDs: any;

  getCoreUserDetails() {
    this.PCCPatientIDs = "";
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var Module = [];
    Module = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core);
    if (Module.length > 0) {
      this.folderId = Module[0].folderID;
    }
    this.coreVm.DatabaseID = Number(this.databaseId);
    this.coreVm.OrganizationID = Number(this.organizationId);
    this.coreVm.coreID = Number(sessionStorage.getItem('transactionID'));
    this.coreVm.FolderId = this.folderId;//17;//this.transactionID; 
    this.coreVm.subFolderID = Number(this.TypeIdDrp);  //37; 
    this.coreVm.officeID = this.myOfficeID;
    this.coreVm.OfficeIDList = this.OfficeIDList;
    this.contactsService.getCoreUserDetails(this.coreVm).subscribe((response) => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          let PCCPatientID = response.data.patientId;
          this.PCCPatientIDs = response.data.patientId;
          if (PCCPatientID == null || PCCPatientID == "null" || PCCPatientID == undefined || PCCPatientID == "") {
            this.PCCPatientIDShow = false;
          } else {
            this.PCCPatientIDShow = true;
          }
        }
      }
    });
  }


  getNormalAndSharedContacts() {
    this.getCoreUserDetails();

    this.contactsVm.DatabaseID = Number(this.databaseId);
    this.contactsVm.OrganizationID = Number(this.organizationId);
    this.contactsVm.UserID = this.currentUser.UID;
    this.contactsVm.CoreID = Number(sessionStorage.getItem("transactionID"));
    this.contactsVm.OfficeID = this.myOfficeID;
    this.loaderService.show();
    this.contactsService.getNormalAndSharedContacts(this.contactsVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.Owners = response.data.owners;
          this.NormalContacts = response.data.contactListModel;
          this.SharedContacts = response.data.sharedContactListModel;
          this.SharedRoleList = response.data.sharedRoleListModel;
          if (this.Owners != null) {
            this.Owners.forEach(e => {
              e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
              e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
              e.shortName = e.name.match(/\b(\w)/g).join('');
            });
          }
          if (this.Owners == null) {
            this.Owners = [];
          }
          if (this.SharedContacts != null) {
            this.SharedContacts.forEach(e => {
              if (e.userID > 0) {
                e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                e.shortName = e.name.match(/\b(\w)/g).join('');
              } else {
                e.shortName = e.name.match(/\b(\w)/g).join('');
              }
              if (e.contactCoreRoleMappingModels == null) {
                e.contactCoreRoleMappingModels = [];
              }
            });
          }
          if (this.NormalContacts != null) {
            this.NormalContacts.forEach(e => {
              e.shortName = e.name.match(/\b(\w)/g).join('');
            });
          }
          this.SharedRoleList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  getNormalAndSharedCompanys() {
    this.companysVm.DatabaseID = Number(this.databaseId);
    this.companysVm.OrganizationID = Number(this.organizationId);
    this.companysVm.UserID = this.currentUser.UID;
    this.companysVm.CoreID = Number(sessionStorage.getItem("transactionID"));
    this.companysVm.OfficeID = this.myOfficeID;
    this.loaderService.show();
    this.contactsService.getNormalAndSharedCompanys(this.companysVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.NormalCompanys = response.data.companyListModel;
          if (this.NormalCompanys != null) {
            this.NormalCompanys.forEach(e => {
              e.shortName = e.name.match(/\b(\w)/g).join('');
            });
          }
          this.loaderService.hide();
        } else {
          this.loaderService.hide();
        }
      }
      else {
        this.loaderService.hide();
      }
    });
  }

  getContactListCoreImplementation(searchValue: any) {
    this.filteredContactVm.DatabaseID = Number(this.databaseId);
    this.filteredContactVm.OrganizationID = Number(this.organizationId);
    this.filteredContactVm.UserID = this.currentUser.UID;
    this.filteredContactVm.searchValue = searchValue;
    this.searchName = searchValue;
    this.filteredContactVm.CoreID = Number(sessionStorage.getItem("transactionID"));
    this.coreID = Number(sessionStorage.getItem("transactionID"));
    this.filteredContactVm.PageSize = 0;
    this.filteredContactVm.officeID = this.myOfficeID;
    this.contactsService.GetContactListCoreImplementation(this.filteredContactVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.contactsList = response.data.contactListModel;
          this.contactsList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
          this.contactsList.push(
            {
              "contactID": 0,
              "coreID": 0,
              "name": "Create New",
              "email": "",
              "imageUrl": "",
              "isShared": this.isShare,
              "coreContactUserMapID": 0,
              "trasactionalRoleIds": [],
              "contactCoreRoleMappingModels": [],
              "shortName": "CN"
            }
          )
        }
      } else {
        this.loaderService.hide();
      }
    });
  }

  CreatePendingContactPCC(contact: any) {
    //let PCCPatientID=sessionStorage.getItem("PCCPatientID");
    if (this.PCCPatientIDs == null || this.PCCPatientIDs == "null" || this.PCCPatientIDs == undefined || this.PCCPatientIDs == "") {
      this.toastr.warning('Please add the patient to PointClickCare, complete their acceptance, and then try again.', '', {
        timeOut: 3000,
      });
      return;
    }
    let associatedAPIs = JSON.parse(sessionStorage.getItem("associatedAPIs"));
    let thirdPartyApiID = 0;
    let officeThirdPartyApiID = 0;
    if (associatedAPIs && associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isContactMapped == true)) {
      thirdPartyApiID = associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isContactMapped == true).thirdPartyApiID;
      officeThirdPartyApiID = associatedAPIs.find(x => x.apiName == 'PointClickCare' && x.isContactMapped == true).officeThirdPartyApiID;
    }
    else if (thirdPartyApiID == 0) {
      this.toastr.warning('PointClickCare is not activated. Please activate it in Settings > Integrations and complete endpoint field mappings.', '', {
        timeOut: 3000,
      });
      return;
    }
    let requestModel = {
      "coreID": Number(sessionStorage.getItem("transactionID")),
      "contactID": contact.contactID,
      "thirdPartyApiID": thirdPartyApiID,
      "officeThirdPartyApiID": officeThirdPartyApiID,
      "userID": this.currentUser.UID,
      "organizationID": Number(this.organizationId),
      "officeID": this.myOfficeID,
      "databaseID": Number(this.databaseId)
    };
    this.loaderService.show();
    this.contactsService.CreatePendingContactPCC(requestModel).subscribe(response => {
      if (response != undefined) {
        this.loaderService.hide();
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (this.responseHolder.data.errors && this.responseHolder.data.errors.length > 0) {
            this.showError(this.responseHolder.data.errors);
          }
          else {
            this.toastr.success('Successfully added to PointClickCare.', '', {
              timeOut: 3000,
            });
          }
        }
      }
      else {
        this.loaderService.hide();
      }
    });

  }

  showError(error: any[]) {
    // Create a container div for the popup
    const popup = document.createElement('div');
    popup.style.position = 'fixed';
    popup.style.top = '50%';
    popup.style.left = '50%';
    popup.style.transform = 'translate(-50%, -50%)';
    popup.style.width = '80%';
    popup.style.maxWidth = '800px';
    popup.style.maxHeight = '150vh';
    popup.style.backgroundColor = 'white';
    popup.style.border = '1px solid #ccc';
    popup.style.borderRadius = '8px';
    popup.style.boxShadow = '0 4px 8px rgba(0,0,0,0.2)';
    popup.style.zIndex = '1000';
    popup.style.overflow = 'auto';
    popup.style.padding = '20px';

    // Create a close button
    const closeButton = document.createElement('button');
    closeButton.textContent = '×';
    closeButton.style.position = 'absolute';
    closeButton.style.top = '10px';
    closeButton.style.right = '10px';
    closeButton.style.background = 'none';
    closeButton.style.border = 'none';
    closeButton.style.fontSize = '20px';
    closeButton.style.cursor = 'pointer';
    closeButton.onclick = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popup);
    };

    // Create a title
    const title = document.createElement('h2');
    title.textContent = this.ContactName + ' Errors';
    title.style.marginTop = '0';
    title.style.color = '#d32f2f';

    // Create a container for error items
    const errorContainer = document.createElement('div');

    // Process each error
    const medicationDiv = document.createElement('div');
    medicationDiv.style.marginBottom = '15px';
    medicationDiv.style.padding = '10px';
    medicationDiv.style.borderBottom = '1px solid #eee';


    const nameLabel = document.createElement('strong');
    nameLabel.textContent = 'Fix issue(s) to Push';
    nameLabel.style.display = 'block';
    nameLabel.style.marginBottom = '5px';
    nameLabel.style.fontSize = '16px';
    medicationDiv.appendChild(nameLabel);
    let index = 1;
    error.forEach(err => {

      const errorDetail = document.createElement('div');
      errorDetail.textContent = index + ". " + err.detail || index + '. No error details available';
      errorDetail.style.color = '#666';
      errorDetail.style.whiteSpace = 'pre-wrap'; // Preserve formatting and wrap text
      errorDetail.style.overflowWrap = 'break-word'; // Break long words if needed


      medicationDiv.appendChild(errorDetail);
      index = index + 1;
    });

    errorContainer.appendChild(medicationDiv);

    // Add elements to popup
    popup.appendChild(closeButton);
    popup.appendChild(title);
    popup.appendChild(errorContainer);

    // Add overlay
    const overlay = document.createElement('div');
    overlay.style.position = 'fixed';
    overlay.style.top = '0';
    overlay.style.left = '0';
    overlay.style.width = '100%';
    overlay.style.height = '100%';
    overlay.style.backgroundColor = 'rgba(0,0,0,0.5)';
    overlay.style.zIndex = '999';
    overlay.onclick = () => {
      document.body.removeChild(overlay);
      document.body.removeChild(popup);
    };

    // Add to document
    document.body.appendChild(overlay);
    document.body.appendChild(popup);
  }


  getCompanyListCoreImplementation(searchValue: any) {
    this.filteredCompanyVm.DatabaseID = Number(this.databaseId);
    this.filteredCompanyVm.OrganizationID = Number(this.organizationId);
    this.filteredCompanyVm.UserID = this.currentUser.UID;
    this.filteredCompanyVm.searchValue = searchValue;
    this.searchName = searchValue;
    this.filteredCompanyVm.CoreID = Number(sessionStorage.getItem("transactionID"));
    this.coreID = Number(sessionStorage.getItem("transactionID"));
    this.filteredCompanyVm.PageSize = 0;
    this.filteredCompanyVm.officeID = this.myOfficeID;
    this.contactsService.GetCompanyListCoreImplementation(this.filteredCompanyVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.companysList = response.data.companyListModel;
          this.companysList.forEach(e => {
            e.shortName = e.name.match(/\b(\w)/g).join('');
          });
          this.companysList.push(
            {
              "companyID": 0,
              "coreID": 0,
              "name": "Create New",
              "email": "",
              "imageUrl": "",
              "isShared": this.isShare,
              "coreCompanyUserMapID": 0,
              "trasactionalRoleIds": [],
              "companyCoreRoleMappingModels": [],
              "shortName": "CN"
            }
          )
        }
      }
    });
  }

  getTransactinalRoles(searchValue: any) {
    this.filteredContactVm.DatabaseID = Number(this.databaseId);
    this.filteredContactVm.OrganizationID = Number(this.organizationId);
    this.filteredContactVm.UserID = this.currentUser.UID;
    this.filteredContactVm.searchValue = searchValue;
    this.filteredContactVm.PageSize = 0;
    this.filteredContactVm.officeID = this.myOfficeID;
    this.filteredContactVm.officeIDList = this.OfficeIDList;
    this.contactsService.getTransactinalRoles(this.filteredContactVm).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        this.transRoleList = [];
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.transRoleList = response.data.transactionalRolesModels;
          //this.transRoleList=this.transRoleList.filter(m=>!this.currentRoleContact.trasactionalRoleIds.includes(m.transctionalRoleID));
          var check = [];
          check = this.transRoleList.filter((x:any) => x.transactionalRoleName.toLowerCase() == searchValue.toLowerCase());
          if (check.length == 0) {
            this.transRoleList.push(
              {
                "transctionalRoleID": 0,
                "coreID": 0,
                "transactionalRoleName": searchValue,
              })
          }
          //  if(this.transRoleList.length==0){
          //   this.transRoleList.push(
          //     {
          //       "transctionalRoleID":0,
          //       "coreID":0,
          //       "transactionalRoleName":searchValue,
          //     }
          //   ) 
          //  }else{
          //   this.transRoleList.push(
          //     {
          //       "transctionalRoleID":0,
          //       "coreID":0,
          //       "transactionalRoleName":searchValue,
          //     }
          //   ) 
          //  }

        } else {
          this.transRoleList = [];
        }
      } else {
        this.transRoleList = [];
      }
    });
  }

  RoleSelected(roleSelected: any) {
    let role = this.Roles.find(m => m.transctionalRoleID == roleSelected.transctionalRoleID);
    if (roleSelected.transctionalRoleID == 0) {
      if (this.currentRoleContact.contactCoreRoleMappingModels.find(m => m.rloeName.toLowerCase() == roleSelected.transactionalRoleName.toLowerCase()) != undefined) {
        this.toastr.warning('Role already selected.', '', {
          timeOut: 1000,
        });
        return;
      }
      let newRole = this.Roles.find(m => m.transactionalRoleName.toLowerCase() == roleSelected.transactionalRoleName.toLowerCase());
      if (newRole == undefined) {
        this.Roles.push({
          transactionalRoleName: roleSelected.transactionalRoleName,
          transctionalRoleID: roleSelected.transctionalRoleID,
          coreID: Number(sessionStorage.getItem("transactionID")),
          contactID: Number(this.currentRoleContact.contactID),
          //userID :Number(this.currentRoleContact.userID),
        });
        if (this.Roles.length > 0) {
          this.showContactRoleAddButton = true;
        }
        if (this.Roles.length == 0) {
          this.showContactRoleAddButton = false;
        }
      }
      return;
    }

    if (role == undefined || role == '' || role == null) {
      if (this.currentRoleContact.contactCoreRoleMappingModels.find(m => m.transctionalRoleID == roleSelected.transctionalRoleID) != undefined) {
        this.toastr.warning('Role already added.', '', {
          timeOut: 1000,
        });
        return;
      }
      this.Roles.push({
        transactionalRoleName: roleSelected.transactionalRoleName,
        transctionalRoleID: roleSelected.transctionalRoleID,
        coreID: Number(sessionStorage.getItem("transactionID")),
        contactID: Number(this.currentRoleContact.contactID),
        //userID :Number(this.currentRoleContact.userID),
      });
    }

    if (this.Roles.length > 0) {
      this.showContactRoleAddButton = true;
    }
    if (this.Roles.length == 0) {
      this.showContactRoleAddButton = false;
    }
  }

  deleteSelectedContact(CoreID: any, ContactID: any, CoreContactUserMapID: any) {
    const message = `Are you sure you want to delete this record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        this.contactsVm.DatabaseID = Number(this.databaseId);
        this.contactsVm.OrganizationID = Number(this.organizationId);
        this.contactsVm.UserID = this.currentUser.UID;
        this.contactsVm.CoreID = Number(sessionStorage.getItem("transactionID"));
        this.contactsVm.CoreID = Number(CoreID);
        this.contactsVm.CoreContactUserMapID = Number(CoreContactUserMapID);
        this.contactsVm.ContactID = Number(ContactID);
        this.contactsVm.CoreContactRoleID = 0;
        this.loaderService.show();
        this.contactsService.deleteSelectedContact(this.contactsVm).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.Owners = response.data.owners;
              this.NormalContacts = response.data.contactListModel;
              this.SharedContacts = response.data.sharedContactListModel;
              this.SharedRoleList = response.data.sharedRoleListModel;
              if (this.Owners != null) {
                this.Owners.forEach(e => {
                  e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                  e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }
              if (this.Owners == null) {
                this.Owners = [];
              }

              if (this.SharedContacts != null) {
                this.SharedContacts.forEach(e => {
                  if (e.userID > 0) {
                    e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                    e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  } else {
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  }
                  if (e.contactCoreRoleMappingModels == null) {
                    e.contactCoreRoleMappingModels = [];
                  }
                });
              }
              if (this.NormalContacts != null) {
                this.NormalContacts.forEach(e => {
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }
              this.SharedRoleList.forEach(e => {
                e.shortName = e.name.match(/\b(\w)/g).join('');
              });
              this.toastr.success('Record deleted successfully.', '', {
                timeOut: 1000,
              });
              this.loaderService.hide();
            }
          }
        });
      }
    });
  }

  deleteSelectedCompany(CoreID: any, CompanyID: any, CompanyCoreUserMapID: any) {
    const message = `Are you sure you want to delete this record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        this.companysVm.DatabaseID = Number(this.databaseId);
        this.companysVm.OrganizationID = Number(this.organizationId);
        this.companysVm.UserID = this.currentUser.UID;
        this.companysVm.CoreID = Number(sessionStorage.getItem("transactionID"));
        this.companysVm.CoreID = Number(CoreID);
        this.companysVm.CompanyCoreUserMapID = Number(CompanyCoreUserMapID);
        this.companysVm.CompanyID = Number(CompanyID);
        this.companysVm.companyCoreRoleID = 0;
        this.loaderService.show();
        this.contactsService.deleteSelectedCompany(this.companysVm).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.NormalCompanys = response.data.companyListModel;
              if (this.NormalCompanys != null) {
                this.NormalCompanys.forEach(e => {
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }
              this.toastr.success('Record deleted successfully.', '', {
                timeOut: 1000,
              });
              this.loaderService.hide();
            }
          }
        });
      }
    });

  }



  contactSelected(contactSelected: any) {
    if (contactSelected.contactID == 0) {
      this.dialog.closeAll();
      //this.addNew('Contact');
      this.addNew(this.ContactName);
      return;
    }
    let contact = this.peoples.find(m => m.contactID == contactSelected.contactID);

    if (contact == undefined || contact == '' || contact == null) {
      this.peoples.push({
        name: contactSelected.name,
        email: contactSelected.email,
        img: contactSelected.imageUrl,
        contactID: contactSelected.contactID,
        roleID: 0,
        isShared: this.isShare,
        isOwner: false,
        shortName: contactSelected.shortName,
        CoreID: Number(sessionStorage.getItem("transactionID"))
      });
      if (this.peoples.length > 0) {
        this.showAddButton = true;
      }
      else {
        this.showAddButton = false;
      }
    }
  }


  companySelected(companySelected: any) {
    if (companySelected.companyID == 0) {
      this.dialog.closeAll();
      // this.addNew('Company');
      this.addNew(this.CompanyName);
      return;
    }
    let company = this.selectedcompanyList.find(m => m.companyID == companySelected.companyID);

    if (company == undefined || company == '' || company == null) {
      this.selectedcompanyList.push({
        name: companySelected.name,
        email: companySelected.email,
        img: companySelected.imageUrl,
        companyID: companySelected.companyID,
        isShared: this.isShare,
        shortName: companySelected.shortName,
        CoreID: Number(sessionStorage.getItem("transactionID"))
      });
      if (this.selectedcompanyList.length > 0) {
        this.showAddButton = true;
      }
      else {
        this.showAddButton = false;
      }
    }
  }


  RoleSelectedForCompany(roleSelected: any) {
    let role = this.RolesCompany.find(m => m.transctionalRoleID == roleSelected.transctionalRoleID);
    if (roleSelected.transctionalRoleID == 0) {
      if (this.currentRoleCompany.companyCoreRoleMappingModels.find(m => m.rloeName.toLowerCase() == roleSelected.transactionalRoleName.toLowerCase()) != undefined) {
        this.toastr.warning('Role already selected.', '', {
          timeOut: 1000,
        });
        return;
      }
      let newRole = this.RolesCompany.find(m => m.transactionalRoleName.toLowerCase() == roleSelected.transactionalRoleName.toLowerCase());
      if (newRole == undefined) {
        this.RolesCompany.push({
          transactionalRoleName: roleSelected.transactionalRoleName,
          transctionalRoleID: roleSelected.transctionalRoleID,
          CoreID: Number(sessionStorage.getItem("transactionID")),
          CompanyID: Number(this.currentRoleCompany.companyID)
        });
        if (this.RolesCompany.length > 0) {
          this.showCompanyRoleAddButton = true;
        }
        if (this.RolesCompany.length == 0) {
          this.showCompanyRoleAddButton = false;
        }
      }
      return;
    }
    if (this.currentRoleCompany.companyCoreRoleMappingModels.find(m => m.transctionalRoleID == roleSelected.transctionalRoleID) != undefined) {
      this.toastr.warning('Role already added.', '', {
        timeOut: 1000,
      });
      return;
    }

    if (role == undefined || role == '' || role == null) {
      this.RolesCompany.push({
        transactionalRoleName: roleSelected.transactionalRoleName,
        transctionalRoleID: roleSelected.transctionalRoleID,
        CoreID: Number(sessionStorage.getItem("transactionID")),
        CompanyID: Number(this.currentRoleCompany.companyID)
      });
    }

    if (this.RolesCompany.length > 0) {
      this.showCompanyRoleAddButton = true;
    }
    if (this.RolesCompany.length == 0) {
      this.showCompanyRoleAddButton = false;
    }
  }

  removeItemRoleCompany(item: any, isRolePopup: boolean) {
    if (this.isRolePopup) {
      const index = this.RolesCompany.indexOf(item);
      if (index >= 0) {
        this.RolesCompany.splice(index, 1);
      }
      if (this.RolesCompany.length > 0) {
        this.showCompanyRoleAddButton = true;
      }
      if (this.RolesCompany.length == 0) {
        this.showCompanyRoleAddButton = false;
      }
    }
  }

  addUpdateCoreContactRole() {
    if (this.Roles.length > 0) {
      this.ContactRoleUpdate();
    }
  }

  addUpdateCoreCompanyRole() {
    if (this.RolesCompany.length > 0) {
      this.CompanyRoleUpdate();
    }
  }


  ContactRoleUpdate() {
    if (this.Roles.length > 0) {
      this.dialog.closeAll();
      this.contactsVm.DatabaseID = Number(this.databaseId);
      this.contactsVm.OrganizationID = Number(this.organizationId);
      this.contactsVm.UserID = this.currentUser.UID;
      this.contactsVm.IsAdded = true;
      this.contactsVm.CoreContactRoleModels = this.Roles;
      this.contactsVm.OfficeID = this.myOfficeID;
      this.contactsVm.sharedUserID = Number(this.currentRoleContact.userID);
      this.loaderService.show();
      this.contactsService.addUpdateCoreContactRole(this.contactsVm).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.NormalContacts = response.data.contactListModel;
            this.SharedContacts = response.data.sharedContactListModel;

            if (this.SharedContacts != null) {
              this.SharedContacts.forEach(e => {
                if (e.userID > 0) {
                  e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                  e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                } else {
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                }
                if (e.contactCoreRoleMappingModels == null) {
                  e.contactCoreRoleMappingModels = [];
                }
              });
            }
            if (this.NormalContacts != null) {
              this.NormalContacts.forEach(e => {
                e.shortName = e.name.match(/\b(\w)/g).join('');
              });
            }
            this.Roles = [];
            this.loaderService.hide();
          }
        } else {
          this.loaderService.hide();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  CompanyRoleUpdate() {
    if (this.RolesCompany.length > 0) {
      this.dialog.closeAll();
      this.companysVm.DatabaseID = Number(this.databaseId);
      this.companysVm.OrganizationID = Number(this.organizationId);
      this.companysVm.UserID = this.currentUser.UID;
      this.companysVm.IsAdded = true;
      this.companysVm.CoreContactCompanyRoleModels = this.RolesCompany;
      this.loaderService.show();
      this.contactsService.addUpdateCoreCompanyRole(this.companysVm).subscribe(response => {
        if (response != undefined) {
          this.loaderService.hide();
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.NormalCompanys = response.data.companyListModel;
            if (this.NormalCompanys != null) {
              this.NormalCompanys.forEach(e => {
                e.shortName = e.name.match(/\b(\w)/g).join('');
              });
            }
            this.RolesCompany = [];
          }
        } else {
          this.loaderService.hide();
        }
      });
    } else {
      this.dialog.closeAll();
    }
  }

  addUpdateCoreContact() {
    if (this.isSharedAccessRolePopup == false && this.isSharedAccessUserPopup == false) {
      if (this.peoples.length > 0) {
        this.dialog.closeAll();
        this.contactsVm.DatabaseID = Number(this.databaseId);
        this.contactsVm.OrganizationID = Number(this.organizationId);
        this.contactsVm.UserID = this.currentUser.UID;
        this.contactsVm.AddUpdateCoreContactListModel = this.peoples;
        this.contactsVm.OfficeID = this.myOfficeID;
        this.loaderService.show();
        this.contactsService.addUpdateCoreContact(this.contactsVm).subscribe(response => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.NormalContacts = response.data.contactListModel;
              this.SharedContacts = response.data.sharedContactListModel;
              if (this.SharedContacts != null) {
                this.SharedContacts.forEach(e => {
                  if (e.userID > 0) {
                    e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                    e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  } else {
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  }
                  if (e.contactCoreRoleMappingModels == null) {
                    e.contactCoreRoleMappingModels = [];
                  }
                });
              }
              if (this.NormalContacts != null) {
                this.NormalContacts.forEach(e => {
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }
              this.peoples = [];
              this.selectedcompanyList = [];
              this.showAddButton = false;
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
      else {
        this.dialog.closeAll();
      }
    }

    if (this.isSharedAccessRolePopup == true && this.isSharedAccessUserPopup == false) {
      if (this.selectedsharedAccessRole.length > 0) {
        this.dialog.closeAll();
        this.contactsVm.DatabaseID = Number(this.databaseId);
        this.contactsVm.OrganizationID = Number(this.organizationId);
        this.contactsVm.UserID = this.currentUser.UID;
        this.contactsVm.AddUpdateCoreContactListModel = this.selectedsharedAccessRole;
        this.contactsVm.OfficeID = this.myOfficeID;
        this.loaderService.show();
        this.contactsService.addUpdateCoreContact(this.contactsVm).subscribe(response => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.Owners = response.data.owners;
              this.NormalContacts = response.data.contactListModel;
              this.SharedContacts = response.data.sharedContactListModel;
              this.SharedRoleList = response.data.sharedRoleListModel;
              if (this.Owners != null) {
                this.Owners.forEach(e => {
                  e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                  e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }

              if (this.Owners == null) {
                this.Owners = [];
              }

              if (this.SharedContacts != null) {
                this.SharedContacts.forEach(e => {
                  if (e.userID > 0) {
                    e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                    e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  } else {
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  }
                  if (e.contactCoreRoleMappingModels == null) {
                    e.contactCoreRoleMappingModels = [];
                  }
                });
              }
              // this.SharedContacts.forEach(e => {
              //   e.shortName=e.name.match(/\b(\w)/g).join('');
              // });
              this.SharedRoleList.forEach(e => {
                e.shortName = e.name.match(/\b(\w)/g).join('');
              });
              if (this.NormalContacts != null) {
                this.NormalContacts.forEach(e => {
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }
              this.selectedsharedAccessRole = [];
              this.selectedcompanyList = [];
              this.showAddButton = false;
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
      else {
        this.dialog.closeAll();
      }

    }

    if (this.isSharedAccessUserPopup == true) {
      if (this.userSelectedList.length > 0) {
        this.dialog.closeAll();
        this.contactsVm.DatabaseID = Number(this.databaseId);
        this.contactsVm.OrganizationID = Number(this.organizationId);
        this.contactsVm.UserID = this.currentUser.UID;
        this.contactsVm.AddUpdateCoreContactListModel = this.userSelectedList;
        this.contactsVm.OfficeID = this.myOfficeID;
        this.loaderService.show();
        this.contactsService.addUpdateCoreContact(this.contactsVm).subscribe(response => {
          if (response != undefined) {
            this.loaderService.hide();
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.NormalContacts = response.data.contactListModel;
              this.SharedContacts = response.data.sharedContactListModel;
              this.Owners = response.data.owners;

              if (this.SharedContacts != null) {
                this.SharedContacts.forEach(e => {
                  if (e.userID > 0) {
                    e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                    e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  } else {
                    e.shortName = e.name.match(/\b(\w)/g).join('');
                  }
                  if (e.contactCoreRoleMappingModels == null) {
                    e.contactCoreRoleMappingModels = [];
                  }
                });
              }
              if (this.Owners != null) {
                this.Owners.forEach(e => {
                  e.name = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.name) + ' ' + this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.lastName);
                  e.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, e.email);
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }

              if (this.Owners == null) {
                this.Owners = [];
              }
              if (this.NormalContacts != null) {
                this.NormalContacts.forEach(e => {
                  e.shortName = e.name.match(/\b(\w)/g).join('');
                });
              }
              this.peoples = [];
              this.selectedcompanyList = [];
              this.showAddButton = false;
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
      else {
        this.dialog.closeAll();
      }
    }
  }




  addUpdateCoreCompany() {
    if (this.selectedcompanyList.length > 0) {
      this.dialog.closeAll();
      this.companysVm.DatabaseID = Number(this.databaseId);
      this.companysVm.OrganizationID = Number(this.organizationId);
      this.companysVm.UserID = this.currentUser.UID;
      this.companysVm.OfficeID = this.myOfficeID;
      this.companysVm.AddUpdateCoreContactCompanyListModel = this.selectedcompanyList;
      this.loaderService.show();
      this.contactsService.addUpdateCoreCompany(this.companysVm).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.NormalCompanys = response.data.companyListModel;
            if (this.NormalCompanys != null) {
              this.NormalCompanys.forEach(e => {
                e.shortName = e.name.match(/\b(\w)/g).join('');
              });
            }
            this.selectedcompanyList = [];
            this.showAddButton = false;
            this.loaderService.hide();
          }
        }
      });
    }
    else {
      this.dialog.closeAll();
    }
  }

  removeItem(item: any, isRolePopup: boolean) {
    if (this.isRolePopup) {
      const index = this.Roles.indexOf(item);
      if (index >= 0) {
        this.Roles.splice(index, 1);
      }
    }
    else {
      const index = this.peoples.indexOf(item);
      if (index >= 0) {
        this.peoples.splice(index, 1);
      }
    }
    if (this.peoples.length == 0) {
      this.showAddButton = false;
    }
    if (this.Roles.length > 0) {
      this.showContactRoleAddButton = true;
    }
    if (this.Roles.length == 0) {
      this.showContactRoleAddButton = false;
    }
  }

  removeItemCompany(item: any, isRolePopup: boolean) {
    if (this.isRolePopup) {
      const index = this.RolesCompany.indexOf(item);
      if (index >= 0) {
        this.RolesCompany.splice(index, 1);
      }
    }
    else {
      const index = this.selectedcompanyList.indexOf(item);
      if (index >= 0) {
        this.selectedcompanyList.splice(index, 1);
      }
      if (this.selectedcompanyList.length == 0) {
        this.showAddButton = false;
      }
    }
  }



  addShare(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, contact: any) {
    this.isShare = isShare;
    this.isRolePopup = isRole;
    this.isSharedAccessRolePopup = false;
    this.coreID = Number(sessionStorage.getItem("transactionID"));
    if (isRole)
      this.currentRoleContact = contact;
    this.transRoleList = [];
    this.contactsList = [];
    this.companysList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.selectedcompanyList = [];
    this.showContactRoleAddButton = false;
    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.isAddOwner = false;
    this.showAddButton = false;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  addOwner(templateRef: TemplateRef<any>, isShare: boolean, contact: any) {
    this.isShare = isShare;
    this.isSharedAccessRolePopup = false;
    this.coreID = Number(sessionStorage.getItem("transactionID"));
    this.transRoleList = [];
    this.contactsList = [];
    this.companysList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.selectedcompanyList = [];
    this.showContactRoleAddButton = false;
    this.isSharedAccessUserPopup = true;
    this.userSelectedList = [];
    this.isAddOwner = true;
    this.showAddButton = false;
    this.isRolePopup = false;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  addShareCompany(templateRef: TemplateRef<any>, isShare: boolean, isRole: boolean, company: any) {
    this.isShare = isShare;
    this.isRolePopup = isRole;
    this.coreID = Number(sessionStorage.getItem("transactionID"));
    if (isRole)
      this.currentRoleContact = company;
    this.currentRoleCompany = this.currentRoleContact;
    this.transRoleList = [];
    this.contactsList = [];
    this.companysList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedcompanyList = [];
    this.showCompanyRoleAddButton = false;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }

  close() {
    this.peoples = [];
    this.selectedcompanyList = [];
    this.Roles = [];
    this.RolesCompany = [];
    this.selectedsharedAccessRole = [];
    this.showAddButton = false;
    this.sharedAccessUserList = [];
    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.dialog.closeAll();
  }

  deleteRole(coreContactRoleID: any, e: any) {
    const message = `Are you sure you want to delete this relation?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        e.target.parentElement.remove();
        this.contactsVm.DatabaseID = Number(this.databaseId);
        this.contactsVm.OrganizationID = Number(this.organizationId);
        this.contactsVm.UserID = this.currentUser.UID;
        this.contactsVm.CoreContactRoleID = Number(coreContactRoleID);
        this.loaderService.show();
        this.contactsService.deleteSelectedContact(this.contactsVm).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Relation deleted successfully.', '', {
                timeOut: 1000,
              });
              this.getNormalAndSharedContacts();
              this.loaderService.hide();
            }
          }
        });
      }
    });

  }




  deleteCompanyRole(companyCoreRoleID: any, e: any) {
    const message = `Are you sure you want to delete this relation?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        e.target.parentElement.remove();
        this.companysVm.DatabaseID = Number(this.databaseId);
        this.companysVm.OrganizationID = Number(this.organizationId);
        this.companysVm.UserID = this.currentUser.UID;
        this.companysVm.companyCoreRoleID = Number(companyCoreRoleID);
        this.loaderService.show();
        this.contactsService.deleteSelectedRoleCompany(this.companysVm).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Relation deleted successfully.', '', {
                timeOut: 1000,
              });
              this.getNormalAndSharedCompanys();
              this.loaderService.hide();
            }
          }
        });
      }
    });
  }


  //== For Shared Access Role == //

  getSharedAccessRoles(searchValue: any) {
    var ReqModel = {
      searchKey: "",
      pageIndex: 0,
      pageSize: 0,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
      searchValue: searchValue,
      OfficeID: this.myOfficeID
    }
    this.contactsService.getSharedAccessRoles(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessRoleList = response.data;
          this.SharedRoleList;
          if (this.SharedRoleList.length > 0) {
            this.sharedAccessRoleList = this.sharedAccessRoleList.filter(({ roleID: id1 }) => !this.SharedRoleList.some(({ roleID: id2 }) => id2 === id1));
          }
        }
        else {
        }
      }
    });
  }

  RoleSelectedForSharedAccess(roleSelected: any) {
    let role = this.selectedsharedAccessRole.find(m => m.roleID == roleSelected.roleID);
    if (roleSelected.roleID == 0) {
      // if(this.currentRoleCompany.companyCoreRoleMappingModels.find(m=>m.rloeName.toLowerCase()==roleSelected.name.toLowerCase())!=undefined)
      // {
      //   this.toastr.warning('Role already selected.', '', {
      //     timeOut: 1000,
      //   });
      //   return;
      // }
      let newRole = this.selectedsharedAccessRole.find(m => m.name.toLowerCase() == roleSelected.name.toLowerCase());
      if (newRole == undefined) {
        this.selectedsharedAccessRole.push({
          name: roleSelected.roleName,
          email: '',
          img: '',
          contactID: 0,
          roleID: roleSelected.roleID,
          isShared: this.isShare,
          shortName: '',
          CoreID: Number(sessionStorage.getItem("transactionID"))
        });
        if (this.selectedsharedAccessRole.length > 0) {
          this.showAddButton = true;
        }
        if (this.selectedsharedAccessRole.length == 0) {
          this.showAddButton = false;
        }
      }
      return;
    }

    if (role == undefined || role == '' || role == null) {
      this.selectedsharedAccessRole.push({
        name: roleSelected.roleName,
        email: '',
        img: '',
        contactID: 0,
        roleID: roleSelected.roleID,
        isShared: this.isShare,
        shortName: '',
        CoreID: Number(sessionStorage.getItem("transactionID"))
      });
    }

    if (this.selectedsharedAccessRole.length > 0) {
      this.showAddButton = true;
    }
    if (this.selectedsharedAccessRole.length == 0) {
      this.showAddButton = false;
    }
  }

  removeItemRoleSharedAccess(item: any, isSharedAccessRolePopup: boolean) {
    if (this.isSharedAccessRolePopup) {
      const index = this.selectedsharedAccessRole.indexOf(item);
      if (index >= 0) {
        this.selectedsharedAccessRole.splice(index, 1);
      }
      if (this.selectedsharedAccessRole.length > 0) {
        this.showAddButton = true;
      }
      if (this.selectedsharedAccessRole.length == 0) {
        this.showAddButton = false;
      }
    }
  }

  selectSharedAccessRb(value) {
    if (value == 2) {
      this.isSharedAccessRolePopup = true;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.showAddButton = false;
      this.isSharedAccessUserPopup = false;
      this.userSelectedList = [];
    }
    if (value == 1) {
      this.isSharedAccessRolePopup = false;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.showAddButton = false;
      this.isSharedAccessUserPopup = false;
      this.userSelectedList = [];
    }
    if (value == 3) {
      this.isSharedAccessRolePopup = false;
      this.isSharedAccessUserPopup = true;
      this.peoples = [];
      this.selectedsharedAccessRole = [];
      this.userSelectedList = [];
      this.showAddButton = false;
    }
  }

  /* ---- connections panel UI ------------------------------------------------ */

  // Collapsed sections by key: owner | core | contacts | shared | companies
  collapsedSections: { [key: string]: boolean } = {};

  toggleSection(key: string) {
    this.collapsedSections[key] = !this.collapsedSections[key];
  }

  get totalConnections(): number {
    return (this.Owners?.length || 0) + (this.NormalCore?.length || 0) + (this.NormalContacts?.length || 0)
      + (this.SharedContacts?.length || 0) + (this.SharedRoleList?.length || 0) + (this.NormalCompanys?.length || 0);
  }

  // Portal access from the row menu (the checkbox used to live inline)
  togglePortalAccess(contact: any) {
    this.accessOnPortal({ checked: !contact.isPortalAccess } as MatCheckboxChange, contact);
  }

  // (xxx) xxx-xxxx for 10-digit numbers, otherwise as entered
  formatPhone(phone: any): string {
    const raw = (phone ?? '').toString();
    const digits = raw.replace(/\D/g, '');
    return digits.length === 10 ? digits.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3') : raw;
  }

  // Stable soft colour for initials avatars
  // "Daughter · Responsible party" subtitle from a row's relation mappings
  relationText(roles: any[]): string {
    return (roles || []).map(r => r.rloeName).filter(Boolean).join(' · ');
  }

  private readonly avatarTones =['blue', 'violet', 'green', 'amber', 'teal', 'rose'];

  avatarTone(name: string): string {
    let h = 0;
    const s = name || '';
    for (let i = 0; i < s.length; i++) { h = (h * 31 + s.charCodeAt(i)) >>> 0; }
    return this.avatarTones[h % this.avatarTones.length];
  }

  accessOnPortal(event: MatCheckboxChange, data: any): void {
    var ReqModel = {
      ccMappingID: data.coreContactUserMapID,
      cid: data.coreID,
      cType: 1,
      isPortalAccess: event.checked,
      officeID: this.myOfficeID,
      userID: this.currentUser.UID,
      databaseID: Number(this.databaseId),
      organizationID: Number(this.organizationId),
    }
    this.contactsService.addPortalAccessToContact(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          if (event.checked) {
            this.toastr.success('Access to the portal has been successfully granted. Welcome!', '', {
              timeOut: 5000,
            });
          }
          else {
            this.toastr.warning('Access to the portal has been successfully revoked', '', {
              timeOut: 1000,
            });
          }

          this.getNormalAndSharedContacts();
        }
        else {
        }
      }
    });
  }

  selectedUser: any = [] = [];
  userSelectedList: any = [];
  timeout = null;
  isAddOwner: boolean = false;

  searchUser(val) {
    if (val.length >= 2) {
      this.sharedAccessUserList = [];
      if (val != '') {
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getUserListCoreImplementation(val)
        }, 500);
      } else {
        this.sharedAccessUserList = [];
      }
    }
  }

  getUserListCoreImplementation(searchValue: any) {
    if (searchValue == "" || searchValue == null || searchValue == undefined) {
      this.sharedAccessUserList = [];
      return;
    }
    var ReqModel = {
      DatabaseID: Number(this.databaseId),
      OrganizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      searchKey: searchValue.trim(),
      PageSize: 0,
      pageIndex: 0,
      UserID: this.currentUser.UID
    }
    this.contactsService.GetUserList(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.sharedAccessUserList = response.data.userModel;
          this.sharedAccessUserList.map((res) => {
            if (res.email != null) {
              res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
            }
            if (res.firstName != null) {
              res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
            }
            if (res.lastName != null) {
              res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
            }
            return res;
          });
          this.sharedAccessUserList = this.sharedAccessUserList;
        }
      }
    });
  }

  userSelected(userSelected: any) {
    this.stateCtrl.setValue('');
    var user = [];
    user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
    if (user.length == 0) {
      var isOwner = false;
      if (this.isAddOwner == true) {
        isOwner = true;
      } else {
        isOwner = false;
      }

      if (this.isAddOwner == false) {
        var users = [];
        users = this.SharedContacts.filter(m => m.userID == userSelected.userID);
        if (users.length > 0) {
          this.toastr.warning('User allready added in shared access list.', '', {
            timeOut: 3000,
          });
          if (this.userSelectedList.length > 0) {
            this.showAddButton = true;
          }
          else {
            this.showAddButton = false;
          }
          return;
        }
      }

      var shortName = userSelected.firstName.match(/\b(\w)/g).join('');

      this.userSelectedList.push({
        name: userSelected.firstName + " " + userSelected.lastName,
        email: userSelected.email,
        contactID: 0,
        roleID: 0,
        userID: userSelected.userID,
        img: "",
        shortName: shortName,
        isShared: true,
        isOwner: isOwner,
        coreID: Number(sessionStorage.getItem("transactionID"))
      });

    } else {
      this.toastr.warning('User allready added.', '', {
        timeOut: 3000,
      });
    }
    if (this.userSelectedList.length > 0) {
      this.showAddButton = true;
    }
    else {
      this.showAddButton = false;
    }
  }


  // userSelectedForOwner(userSelected: any) {
  //   this.stateCtrl.setValue('');
  //   var user=[];
  //   user = this.userSelectedList.filter(m => m.userID == userSelected.userID);
  //   if (user.length!=0) {
  //     var isOwner=false;
  //     if(this.isAddOwner==true){
  //       isOwner=true;
  //     }else{
  //       isOwner=false;
  //     }
  //     if(this.isAddOwner==true){
  //       var users=[];
  //       users = this.Owners.filter(m => m.userID == userSelected.userID);
  //       if(user.length>0){
  //         this.toastr.warning('User allready added in owner list.', '', {
  //           timeOut: 3000,
  //         });
  //       }
  //       if(this.userSelectedList.length > 0){
  //         this.showAddButton=true;
  //       }
  //       else{
  //         this.showAddButton=false;
  //       } 
  //     }
  //     var shortName = userSelected.firstName.match(/\b(\w)/g).join('');

  //     this.userSelectedList.push({
  //        name: userSelected.firstName + " " + userSelected.lastName,      
  //        email: userSelected.email,
  //        contactID: 0,
  //        roleID:  0,
  //        userID: userSelected.userID,      
  //        img: "",
  //        shortName:shortName,
  //        isShared:true,
  //        isOwner:isOwner,
  //        coreID:Number(sessionStorage.getItem("transactionID"))   
  //     });   

  //   }else{
  //     this.toastr.warning('User allready added.', '', {
  //       timeOut: 3000,
  //     });
  //   }
  //   if(this.userSelectedList.length > 0){
  //     this.showAddButton=true;
  //   }
  //   else{
  //     this.showAddButton=false;
  //   } 
  // }

  removeUser(item: any) {
    const index = this.userSelectedList.indexOf(item);
    if (index >= 0) {
      this.userSelectedList.splice(index, 1);
    }
    if (this.userSelectedList.length == 0) {
      this.showAddButton = false;
    }
  }

  addcore(templateRef: TemplateRef<any>) {
    this.attachedToCoreList = [];
    this.addUpdateParticipantList = [];
    this.stateCtrl.reset();
    this.isShare = false;
    this.isRolePopup = false;
    this.isSharedAccessRolePopup = false;
    this.isSharedAccessUserPopup = false;
    this.coreID = Number(sessionStorage.getItem("transactionID"));
    this.transRoleList = [];
    this.contactsList = [];
    this.companysList = [];
    this.Roles = [];
    this.peoples = [];
    this.selectedsharedAccessRole = [];
    this.selectedcompanyList = [];
    this.showContactRoleAddButton = false;
    this.isSharedAccessUserPopup = false;
    this.userSelectedList = [];
    this.isAddOwner = false;
    this.showAddButton = false;
    const dialogRef = this.dialog.open(templateRef, {
      panelClass: 'custom-modalbox'
    });
  }


  //======================Core============================//

  attachedToCoreList: any = [] = [];
  menuModulesList: any = [] = [];
  CorefolderID: number = 0;
  roleIdList: any = [] = [];
  addUpdateParticipantList: any = [] = [];

  searchCore(val) {
    if (val.length >= 1) {
      this.attachedToCoreList = [];
      if (val != '') {
        this.searchName = val;
        clearTimeout(this.timeout)
        this.timeout = setTimeout(() => {
          this.getsearchCore(val)
        }, 500);
      } else {
        this.attachedToCoreList = [];
      }
    }
  }



  getsearchCore(searchValue: any) {
    // var SelectedCCC = [];
    // SelectedCCC = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Core');
    // if (SelectedCCC.length > 0) {
    //   this.CorefolderID = SelectedCCC[0].folderID;
    // }
    
    var menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));
    var SelectedCCC = [];
    SelectedCCC = menuModulesList.filter((x:any) => x.mainModuleName == ModuleName.Core);
    if (SelectedCCC.length > 0) {
      this.CorefolderID = SelectedCCC[0].folderID;
    }
    this.roleIdList = [];
    let roles = sessionStorage.getItem('roleIDList').split(',');
    roles.forEach(e => {
      this.roleIdList.push(Number(e));
    });

    var ReqModel = {
      roleIDList: this.roleIdList,
      searchKey: searchValue,
      userContactID: Number(sessionStorage.getItem('userContactID')),
      folderID: this.CorefolderID,
      databaseID: Number(this.databaseId),
      userID: this.currentUser.UID,
      officeID: this.myOfficeID,
      organizationID: Number(this.organizationId),
      officeIDList: this.OfficeIDList
    }
    this.contactsService.searchCore(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.attachedToCoreList = response.data;

          // this.attachedToCoreList.push(
          //   {           
          //     "coreID":0,
          //     "name":"Create New",
          //     "email":"",
          //     "imageUrl":"",
          //     "isShared":false,                       
          //     "shortName":""
          // })

        } else {
          this.attachedToCoreList = [];
        }
      }
    })
  }


  coreSelectedNew(coreSelected: any) {
    // if (coreSelected.coreID == 0) {
    //   this.dialog.closeAll();     
    //   this.addNew(this.CoreName);
    //   return;
    // }
    //  Check if already exists
     const isDuplicate = this.addUpdateParticipantList.some(item => item.coreID === coreSelected.coreID)
     || this.NormalCore.some(item => item.attachedCoreID === coreSelected.coreID);

      if (isDuplicate) {
        this.toastr.warning('Record is already added', '', {
          timeOut: 3000,
        });
        this.stateCtrl.setValue('');
        return;
      }

    this.stateCtrl.setValue('');
    var shortName = "";
    shortName = coreSelected.name.match(/\b(\w)/g).join('');

    var obj = {
      name: coreSelected.name,
      email: coreSelected.email,
      coreID: coreSelected.coreID,
      img: coreSelected.imageUrl,
      shortName: shortName
    }
    this.addUpdateParticipantList.push(obj);
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = true;
    } else {
      this.showAddButton = false;
    }
  }

  removeParticipant(item: any) {
    const index = this.addUpdateParticipantList.indexOf(item);
    if (index >= 0) {
      this.addUpdateParticipantList.splice(index, 1);
    }
    if (this.addUpdateParticipantList.length > 0) {
      this.showAddButton = true;
    } else {
      this.showAddButton = false;
    }
  }


  addUpdateCoreToCore() {
    if (this.addUpdateParticipantList.length > 0) {
      var addUpdateCoreToCoreList = [];
      addUpdateCoreToCoreList = this.addUpdateParticipantList.map(item => ({
        attachedCoreID: item.coreID || 0,
        coreID: Number(sessionStorage.getItem('transactionID')),
      }));
      var reqModel = {
        addUpdateCoreToCoreListModel: addUpdateCoreToCoreList,
        userID: this.currentUser.UID,
        organizationID: Number(this.organizationId),
        officeID: Number(this.myOfficeID),
        databaseID: Number(this.databaseId)
      }
      this.loaderService.show();
      this.contactsService.addUpdateCoresToCore(reqModel).subscribe(response => {
        if (response != undefined) {
          this.responseHolder = response;
          this.loaderService.hide();
          if (this.responseHolder.status == this.statusConst.statusSuccess) {
            this.getCoreSelectedCores();
            this.addUpdateParticipantList = [];
            this.dialog.closeAll();
            this.toastr.success('Record added successfully.', '', {
              timeOut: 3000,
            });
            this.loaderService.hide();
          }
        } else {
          this.addUpdateParticipantList = [];
          this.dialog.closeAll();
          this.loaderService.hide();
        }
      });
    }
  }


  deleteSelectedCore(core: any) {
    const message = `Are you sure you want to delete this record?`;
    const title = `Confirm Delete`;
    const confirm = `Delete`;
    const dialogData = new ConfirmDialogModel(title, message, confirm);
    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      panelClass: 'edituserdetails',
      maxWidth: '1000px',
      maxHeight: '500px',
      data: dialogData,
    });
    dialogRef.beforeClosed().subscribe(async (dialogResult) => {
      if (dialogResult) {
        var reqModel = {
          coreToCoreMapID: Number(core.coreToCoreMapID),
          userID: this.currentUser.UID,
          organizationID: Number(this.organizationId),
          officeID: this.myOfficeID,
          databaseID: Number(this.databaseId)
        }
        this.loaderService.show();
        this.contactsService.removeCoreToCoreMapping(reqModel).subscribe(response => {
          if (response != undefined) {
            this.responseHolder = response;
            if (this.responseHolder.status == this.statusConst.statusSuccess) {
              this.toastr.success('Record deleted successfully.', '', {
              timeOut: 3000,
              });
              this.getCoreSelectedCores();
              this.loaderService.hide();
            } else {
              this.loaderService.hide();
            }
          } else {
            this.loaderService.hide();
          }
        });
      }
    });
  }


  getCoreSelectedCores() {
    var reqModel = {    
      coreID: Number(sessionStorage.getItem("transactionID")),
      pageIndex: 0,
      pageSize: 10,
      userID: this.currentUser.UID,
      organizationID: Number(this.organizationId),
      officeID: this.myOfficeID,
      databaseID: Number(this.databaseId)
    }
    this.loaderService.show();
    this.contactsService.getCoreSelectedCores(reqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;
        if (this.responseHolder.status == this.statusConst.statusSuccess) {
          this.loaderService.hide();
          this.NormalCore = response.data.coreListModel;
          if (this.NormalCore != null) {
            this.NormalCore.forEach(e => {
              e.shortName = e.name.match(/\b(\w)/g).join('');
            });
          }
          if (this.NormalCore == null) {
            this.NormalCore = [];
          }         
        } else {
          this.NormalCore=[];
          this.loaderService.hide();
        }
      }
      else {
        this.NormalCore=[];
        this.loaderService.hide();
      }
    });
  }


  states: State[] = [
    {
      name: 'Abbott',
      email: 'Abbott@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Abbott.jpg'
    },
    {
      name: 'Alice',
      email: 'alice.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/alice.jpg'
    },
    {
      name: 'Carl',
      email: 'carl@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/carl.jpg'
    },
    {
      name: 'Jane',
      email: 'jane@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/jane.jpg'
    },
    {
      name: 'Tillman',
      email: 'tillman.@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Tillman.jpg'
    },
    {
      name: 'Josefina',
      email: 'Josefina@gmail.com',
      role: 'agent',
      pic: '../../../../../assets/images/avatars/Josefina.jpg'
    },
    {
      name: 'Create New',
      email: ' ',
      role: ' ',
      pic: ' '
    },

  ];


}